import React from "react";

import Layout from "../../components/layout";
import SEO from "../../components/SEO";
import { JiffyDesignLabProjectSection } from "../../containers/projects";

const JiffyDesignLabProjectPage = () => {
  return (
    <Layout>
      <SEO
        title="Jiffy Design Lab - Projects"
        description="Apparel customization lab on the Jiffy Made path | React, Konva, GraphQL, Rails | WYSIWYG placement and print preparation"
      />
      <JiffyDesignLabProjectSection />
    </Layout>
  );
};

export default JiffyDesignLabProjectPage;
